import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { StepCard } from '../../StepCard/StepCard';

export const HOW_MUCH_SAVED = 'howMuchSaved';

export interface HowMuchSavedFormField {
  [HOW_MUCH_SAVED]?: string;
}

export const HowMuchSavePerMonth = () => {
  const {
    setValue,
    formState: { errors },
    control,
  } = useFormContext<HowMuchSavedFormField>();

  return (
    <StepCard>
      <Text color="neutral.700" fontSize="h3" fontWeight={500}>
        How much do you save per month?
      </Text>
      <Text color="neutral.500" mt="8">
        Your saving habits will help us recommend a reasonable monthly contribution amount for this
        account.
      </Text>

      <Box display="flex" mt="32">
        <Controller
          control={control}
          name={HOW_MUCH_SAVED}
          render={({ field: { value } }) => (
            <InputNumberMask
              label="Monthly savings"
              placeholder="Monthly savings"
              leftIcon="fa fa-dollar-sign"
              name={HOW_MUCH_SAVED}
              value={value}
              formVariant={errors[HOW_MUCH_SAVED] ? 'error' : undefined}
              helperText={errors[HOW_MUCH_SAVED]?.message}
              onValueChange={({ floatValue }) => {
                setValue(HOW_MUCH_SAVED, floatValue !== undefined ? floatValue.toString() : '');
              }}
            />
          )}
        />
      </Box>
    </StepCard>
  );
};
